import {
  observer,
  useTranslation,
  useLocation,
  useNavigate,
  Link,
} from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as LocaleContext from "../../i18n/I18nProvider.jsx";
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as React from "react";
import * as LocalizedPathsModule from "../../routing/localizedPaths.js";
import { createNavigation } from "../../content/navigation.js";
import * as ClassNamesModule from "../../utils/classNames.js";
import * as jsxRuntime from "react/jsx-runtime";
import * as SiteState from "../../state/siteStore.js";
import { NewBadge } from "./DesktopNav.jsx";
let MenuIcon = ({ className: className, size: t = 16 }) => (
  <svg
    className={className}
    width={t}
    height={t}
    viewBox={"0 0 16 16"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <path
      fillRule={"evenodd"}
      clipRule={"evenodd"}
      d={
        "M1.66667 2.33333L14.3333 2.33333L14.3333 3.66667L1.66667 3.66667L1.66667 2.33333ZM1.66667 7.33333L11.5 7.33333L11.5 8.66667L1.66667 8.66667L1.66667 7.33333ZM1.66667 12.3333L6.33333 12.3333L6.33333 13.6667L1.66667 13.6667L1.66667 12.3333Z"
      }
      fill={"currentColor"}
    />
  </svg>
);
let CloseIcon = ({ className: className, size: t = 16 }) => (
  <svg
    className={className}
    width={t}
    height={t}
    viewBox={"0 0 16 16"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <path
      fillRule={"evenodd"}
      clipRule={"evenodd"}
      d={
        "M8 7.05767L12.7123 2.3454L13.6551 3.28821L8.94281 8.00048L13.6551 12.7128L12.7123 13.6556L8 8.94329L3.28774 13.6556L2.34493 12.7128L7.05719 8.00048L2.34493 3.28821L3.28774 2.3454L8 7.05767Z"
      }
      fill={"currentColor"}
    />
  </svg>
);
let PlusIcon = ({ className: className, size: t = 16 }) => (
  <svg
    className={className}
    width={t}
    height={t}
    viewBox={"0 0 16 16"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <path
      fillRule={"evenodd"}
      clipRule={"evenodd"}
      d={
        "M13.6719 6.28613L12.7291 5.34332L8.01502 10.0574L3.30098 5.34332L2.35817 6.28613L7.54357 11.4715C7.54357 11.4715 7.54362 11.4716 8.01502 11.0002L7.54357 11.4715L8.01502 11.943L13.6719 6.28613Z"
      }
      fill={"currentColor"}
    />
  </svg>
);
let MinusIcon = ({ className: className, size: t = 16 }) => (
  <svg
    className={className}
    width={t}
    height={t}
    viewBox={"0 0 16 16"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <path
      d={
        "M5.33333 4.33333H11.6667V10.6667H10.3333V6.60948L4.47138 12.4714L3.52858 11.5286L9.39048 5.66667H5.33333V4.33333Z"
      }
      fill={"currentColor"}
    />
  </svg>
);
let MobileNav = observer(() => {
  let { t: translate } = useTranslation(),
    { language: language, setLanguage: setLanguage } = (0,
    LocaleContext.useI18n)(),
    { pathname: pathname, search: search, hash: hash } = useLocation(),
    l = useNavigate(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    [c, d] = (0, React.useState)(false),
    [f, M] = (0, React.useState)(new Set(["useToken", "pricing"])),
    [y, N] = (0, React.useState)(false),
    headerRef = (0, React.useRef)(null),
    [menuTop, setMenuTop] = (0, React.useState)(52),
    b = !(pathname.startsWith("/docs") || pathname.startsWith("/test-docs")),
    k = pathname.startsWith("/docs"),
    T = pathname.startsWith("/console");
  (0, React.useEffect)(() => {
    if (!b) return;
    let e = document.querySelector("main"),
      t = () => N((e?.scrollTop ?? window.scrollY) > 0);
    return (
      t(),
      e?.addEventListener("scroll", t, {
        passive: true,
      }),
      window.addEventListener("scroll", t, {
        passive: true,
      }),
      () => {
        (e?.removeEventListener("scroll", t),
          window.removeEventListener("scroll", t));
      }
    );
  }, [b]);
  (0, React.useEffect)(() => {
    d(false);
  }, [pathname, language]);
  (0, React.useEffect)(() => {
    let desktopQuery = window.matchMedia("(min-width: 920px)"),
      closeOnDesktop = () => {
        if (desktopQuery.matches) d(false);
      };
    desktopQuery.addEventListener("change", closeOnDesktop);
    return () => desktopQuery.removeEventListener("change", closeOnDesktop);
  }, []);
  (0, React.useEffect)(() => {
    if (!c) return;
    let main = document.querySelector("main"),
      previousOverflow = main?.style.overflow,
      updateMenuTop = () => {
        setMenuTop(headerRef.current?.getBoundingClientRect().bottom ?? 52);
      },
      closeOnEscape = (event) => {
        if (event.key === "Escape") d(false);
      };
    updateMenuTop();
    if (main) main.style.overflow = "hidden";
    window.addEventListener("resize", updateMenuTop);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      if (main) main.style.overflow = previousOverflow;
      window.removeEventListener("resize", updateMenuTop);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [c, SiteState.siteStore.showBanner]);
  let C = b && (y || c),
    w = "";
  k ? (w = translate("nav.docs")) : T && (w = translate("nav.console"));
  let A = () => d(false),
    D = (e) => {
      (setLanguage(e),
        (0, LocalizedPathsModule.CT)(pathname) &&
          l((0, LocalizedPathsModule.ee)(pathname, e) + search + hash, {
            replace: true,
          }),
        A());
    },
    navigation = createNavigation(translate),
    j = [
      { key: "research", type: "link", ...navigation.research },
      {
        key: "model",
        label: translate("nav.model"),
        type: "accordion",
        groups: navigation.modelGroups,
      },
      {
        key: "dynamics",
        label: translate("nav.dynamics"),
        type: "accordion",
        groups: navigation.newsGroups,
      },
      {
        key: "pricing",
        label: translate("nav.pricing"),
        type: "accordion",
        groups: navigation.pricingGroups,
      },
      {
        key: "language",
        label: language === "zh" ? "中文" : "English",
        type: "accordion",
        groups: [
          {
            items: [
              { label: "中文", onClick: () => D("zh") },
              { label: "English", onClick: () => D("en") },
            ],
          },
        ],
      },
      ...(b
        ? [
            {
              key: "useToken",
              label: translate("nav.useMiMo"),
              type: "accordion",
              groups: navigation.usageGroups,
            },
          ]
        : []),
      ...(T
        ? [
            {
              key: "docs",
              label: translate("nav.docCenter"),
              type: "link",
              href: "/docs/welcome",
            },
            {
              key: "docsPricing",
              label: translate("nav.pricing"),
              type: "link",
              href: "/docs/price/pay-as-you-go",
            },
          ]
        : []),
      ...(k
        ? [
            {
              key: "console",
              label: translate("nav.console"),
              type: "link",
              href: "https://platform.xiaomimimo.com/console/balance",
              external: true,
            },
          ]
        : []),
    ];
  return (
    <div
      data-qa={"home-mobile-nav"}
      className={
        "relative flex [@media(min-width:920px)]:hidden flex-col w-full"
      }
    >
      <div
        ref={headerRef}
        className={(0, ClassNamesModule.cn)(
          "h-[52px] flex items-center justify-between py-[8px] w-full transition-colors",
          k ? "px-[16px]" : "px-[28px]",
          C
            ? "bg-[rgba(252,250,248,0.85)] backdrop-blur-[20px] dark:bg-[rgba(255,255,255,0.9)]"
            : "bg-transparent",
        )}
      >
        <div className={"flex items-center gap-[8px]"}>
          <a
            href={"https://www.15token.win/home"}
            target={"_blank"}
            rel={"noopener noreferrer"}
            className={
              "inline-grid leading-[0] place-items-start cursor-pointer hover:opacity-80 transition-opacity shrink-0"
            }
            title={translate("nav.home")}
            aria-label={translate("nav.home")}
            onClick={A}
          >
            <div className={"h-[28px]"}>
              <img
                src={"/images/15token-logo.png"}
                alt={translate("nav.home")}
                className={"h-full w-auto object-contain"}
              />
            </div>
          </a>
          {w && (
            <jsxRuntime.Fragment>
              <div className={"w-px h-[16px] bg-[#d9d9d9]"} />
              <div
                className={
                  "text-[16px] leading-[22px] text-black whitespace-nowrap"
                }
              >
                {w}
              </div>
            </jsxRuntime.Fragment>
          )}
        </div>
        <div className={"flex items-center gap-[16px]"}>
          <button
            type={"button"}
            onClick={() => d((e) => !e)}
            className={"MobileNav_menuToggle__n15tk flex items-center justify-center text-[#1f2329]"}
            aria-label={translate(c ? "nav.banner.close" : "nav.moreActions")}
            aria-expanded={c}
            aria-controls={"mobile-nav-menu"}
          >
            {c ? <CloseIcon size={16} /> : <MenuIcon size={16} />}
          </button>
        </div>
      </div>
      {c && (
        <div
          id={"mobile-nav-menu"}
          className={
            "MobileNav_menuPanel__n15tk fixed left-0 right-0 bottom-0 z-10 flex flex-col px-[16px] pb-[16px] bg-[var(--color-bg-page)] overflow-y-auto overscroll-contain"
          }
          style={{
            top: menuTop,
          }}
        >
          {j.map((e) => {
            if ("link" === e.type) {
              let t =
                "flex h-[56px] items-center justify-between py-[12px] border-b border-[var(--color-border-warm)] text-[16px] leading-[22px] font-medium text-black";
              return e.external ? (
                <a
                  key={e.key}
                  href={e.href}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  className={t}
                  onClick={A}
                >
                  {e.label}
                </a>
              ) : (
                <Link key={e.key} to={e.href} className={t} onClick={A}>
                  {e.label}
                </Link>
              );
            }
            let t = f.has(e.key);
            return (
              <div
                key={e.key}
                className={
                  "flex flex-col border-b border-[var(--color-border-warm)]"
                }
              >
                <button
                  type={"button"}
                  aria-expanded={t}
                  aria-controls={`mobile-nav-${e.key}`}
                  className={
                    "flex h-[56px] items-center justify-between py-[12px] w-full"
                  }
                  onClick={() => {
                    M((t) => {
                      let i = new Set(t);
                      return (i.has(e.key) ? i.delete(e.key) : i.add(e.key), i);
                    });
                  }}
                >
                  <span
                    className={
                      "text-[16px] leading-[22px] font-medium text-black whitespace-nowrap"
                    }
                  >
                    {e.label}
                  </span>
                  <PlusIcon
                    size={16}
                    className={(0, ClassNamesModule.cn)(
                      "text-[#1a1a1a] transition-transform duration-200 shrink-0",
                      t && "-scale-y-100",
                    )}
                  />
                </button>
                {t && (
                  <div
                    id={`mobile-nav-${e.key}`}
                    className={"flex flex-col gap-[8px] pb-[12px]"}
                  >
                    {e.groups.map((e, t) => (
                      <div
                        key={e.heading || `group-${t}`}
                        className={"flex flex-col gap-px"}
                      >
                        {e.heading && (
                          <div
                            className={
                              "flex flex-col pb-[4px] pl-[8px] pr-[12px]"
                            }
                          >
                            <p
                              className={
                                "text-[12px] leading-[14px] tracking-[-0.16px] text-[var(--color-text-secondary)] whitespace-nowrap"
                              }
                            >
                              {e.heading}
                            </p>
                          </div>
                        )}
                        {e.items.map((e) => {
                          let t;
                          return (
                            (t = (
                              <div
                                className={
                                  "MobileNav_menuItem__n15tk flex w-full cursor-pointer items-center rounded-[6px] hover:bg-[var(--color-surface-hover)]"
                                }
                              >
                                <span
                                  className={
                                    "flex min-w-0 flex-1 items-center gap-1"
                                  }
                                >
                                  <span
                                    className={
                                      "break-words text-[14px] leading-[20px] tracking-[-0.16px] text-[#1a1a1a]"
                                    }
                                  >
                                    {e.label}
                                  </span>
                                  {e.isNew && <NewBadge />}
                                </span>
                                {e.external && (
                                  <MinusIcon
                                    size={16}
                                    className={"shrink-0 text-[#1a1a1a]"}
                                  />
                                )}
                              </div>
                            )),
                            e.onClick && !e.href ? (
                              <button
                                type={"button"}
                                key={e.label}
                                onClick={e.onClick}
                                className={"block w-full text-left"}
                              >
                                {t}
                              </button>
                            ) : e.external ? (
                              <a
                                key={e.label}
                                href={e.href}
                                target={"_blank"}
                                rel={"noopener noreferrer"}
                                className={"block w-full"}
                                onClick={() => {
                                  (e.onClick?.(), A());
                                }}
                              >
                                {t}
                              </a>
                            ) : (
                              <Link
                                key={e.label}
                                to={e.href}
                                className={"block w-full"}
                                onClick={() => {
                                  (e.onClick?.(), A());
                                }}
                              >
                                {t}
                              </Link>
                            )
                          );
                        })}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
});
export { MenuIcon, CloseIcon, PlusIcon, MinusIcon, MobileNav };
